export const getNamesOfShadowDevice = (keys: number[]) => {
    const shadowNames: string[] = [];
    keys.forEach((key) => {
        if (key >= 0 && key < 5) {
            shadowNames.push('Relay' + (key + 1).toString() + 'SettingsId');
        } else if (key >= 5 && key < 9) {
            shadowNames.push('Irda' + (key - 4).toString() + 'SettingsId');
        }
    })
    return shadowNames;
}